import { useEffect, useRef, useState } from 'react';
import { getAuthCookie, setAuthCookie } from 'utils/auth';
import { refreshAuthToken } from 'service/cognitoService';
import jwtDecode from 'jwt-decode';
import { reportError } from 'utils/reporting';

const MIN_TOKEN_TIME_TO_EXPIRE = 5 * 60 * 1000;

export const useRefreshToken = () => {
  const [, rescheduleRefresh] = useState();
  const timeout = useRef();
  const auth = getAuthCookie();

  const refreshToken = async () => {
    const authTokens = await refreshAuthToken(auth.refresh_token);
    setAuthCookie({
      ...auth,
      ...authTokens,
    });
    rescheduleRefresh(Math.random());
  };

  useEffect(() => {
    if (auth) {
      try {
        const { id_token } = auth;
        const { exp } = jwtDecode(id_token);

        const timeToRefreshToken = (exp * 1000 - new Date().getTime() - MIN_TOKEN_TIME_TO_EXPIRE);
        if (timeout.current) {
          clearTimeout(timeout.current);
        }

        if (timeToRefreshToken > 0) {
          timeout.current = setTimeout(
            refreshToken,
            timeToRefreshToken,
          );
        }
      } catch (e) {
        reportError(e);
      }
    }

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [auth?.id_token]);
};
